import { httpApi } from '@app/api/http.api';
import { WordItem } from '@app/interfaces/interfaces';

export interface IQuestionByType {
  type: string;
  total: number;
}

export interface IQuestion {
  type: string;
  total: number;
}

export interface IExam {
  id: string;
  audioLink: string;
  text: string;
  orderId: string;
  difficulty: string;
  description: string;
  choices: string;
  oldChoices: string;
  answer: string;
  imageUrl: string;
  topic: string;
  type: string;
  isdone: boolean;
}

export interface IExamList {
  data: IExam[];
  meta: {
    itemCount: number;
    page: number;
    pageCount: number;
    totalDone: number;
  };
}

export interface IScore {
  content?: number;
  pronuciation?: number;
  fluency?: number;
  total: number;
}

export interface IPracticeScore {
  score: IScore;
  total: number;
  words?: WordItem[];
  statusCode: number;
  message: string;
}

export interface IHistoryPractice {
  id: string;
  order_id: string;
  date: string;
  score: IPracticeScore;
  correct_answer: string;
  answer: string;
  time: number;
  type: string;
}

export interface IHistoryPracticeResponse {
  data: IHistoryPractice[];
  meta: {
    itemCount: number;
    page: number;
    pageCount: number;
    totalDone: number;
  };
}

export const getQuestionsByType = (type: string, categories: string[]): Promise<IQuestionByType[]> => {
  const queryString = `questionType=${encodeURIComponent(type)}&${categories
    .map((category) => `questionSubType=${encodeURIComponent(category)}`)
    .join('&')}`;

  return httpApi.get<IQuestionByType[]>(`/questions/grouped-by-type?${queryString}`).then(({ data }) => data);
};

export const getExams = (
  page: number,
  take: number,
  questionSubType: string,
  search: string,
  repeated: boolean,
  difficult: string,
  done: string,
): Promise<IExamList> => {
  const queryString = `order=ASC&page=${page}&take=${take}&questionSubType=${encodeURIComponent(
    questionSubType,
  )}&search=${encodeURIComponent(search)}&repeated=${repeated}&difficulty=${difficult}&done=${done}`;

  return httpApi.get<IExamList>(`/questions?${queryString}`).then(({ data }) => data);
};

export const getDetailExam = (id: string): Promise<IExam> => {
  return httpApi.get<IExam>(`/questions/${id}`).then(({ data }) => data);
};

export const practiceScore = (payload: FormData): Promise<IPracticeScore> =>
  httpApi.post<IPracticeScore>('/questions/practice-score', payload).then(({ data }) => data);

export const practiceHistory = (questionId: string, page: number, take: number): Promise<IHistoryPracticeResponse> => {
  const queryString = `order=ASC&page=${page}&take=${take}&questionId=${encodeURIComponent(questionId)}`;

  return httpApi.get<IHistoryPracticeResponse>(`/user-practice/history?${queryString}`).then(({ data }) => data);
};

export const practiceScoreAI = (userPracticeId: string): Promise<any> =>
  httpApi.get<any>(`/user-practice/${userPracticeId}`).then(({ data }) => data);

export const practiceDelete = (id: string): Promise<any> =>
  httpApi.delete<any>(`/user-practice/${id}`).then(({ data }) => data);
